import React from 'react';

interface Props {
  className: string;
}

const HelpLink: React.FC<Props> = ({ children, className }) => (
  <a
    href="https://modernhealthprovider.zendesk.com/hc/"
    className={className}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'white' }}
  >
    {children}
  </a>
);

export default HelpLink;
